import * as I18n from 'i18n-js';
import * as React from 'react';
import Modal from '@reverbdotcom/commons/dist/components/modal';
import PriceFilters from './price_filters';
import bind from '@reverbdotcom/commons/dist/bind';
import SanitizedRender from '@reverbdotcom/commons/dist/components/sanitized_render';

interface Props {
  headerLabel: string;
  isOpen: boolean;
  onRequestClose: Function;
  onUpdate: Function;
  submit: Function;
  submitLabel: string;
  withPriceFilters?: boolean;
  withUsedFilter?: boolean;
  addGearAlert?: boolean;
  usedOnly?: boolean;
  filterByPrice?: boolean;
  priceMin?: number;
  priceMax?: number;
  readableTitle?: string;
}

export default class FollowModal extends React.Component<Props, null> {
  static get defaultProps(): Partial<Props> {
    return {
      addGearAlert: true,
    };
  }

  @bind
  handleSubmit(e) {
    e.preventDefault();

    this.props.submit();
  }

  @bind
  handleGearAlertChange(e) {
    const addGearAlert = e.target.checked;

    this.props.onUpdate({ addGearAlert });
  }

  @bind
  handleUsedOnlyChange(e) {
    const usedOnly = e.target.checked;
    this.props.onUpdate({ usedOnly });
  }

  renderUsedFilter() {
    if (!this.props.withUsedFilter) { return null; }

    return (
      <div className="feed-modal__option">
        <div className="feed-modal__switch">
          <input
            type="checkbox"
            id="used-only-toggle"
            onChange={this.handleUsedOnlyChange}
            checked={this.props.usedOnly}
          />
          <label htmlFor="used-only-toggle">
            {I18n.t('discovery.addFollowToFeed.usedOnly')}
          </label>
        </div>
      </div>
    );
  }

  renderPriceFilters() {
    if (!this.props.withPriceFilters) { return null; }

    return (
      <PriceFilters
        onUpdate={this.props.onUpdate}
        filterByPrice={this.props.filterByPrice}
        priceMax={this.props.priceMax}
        priceMin={this.props.priceMin}
      />
    );
  }

  renderReadableTitle() {
    // guard against empty
    // also guard generic "Gear" titles, until we fix the response for CSPs
    if (!this.props.readableTitle) { return null; }

    return (
      <small className="feed-modal__header__follow-title">
        <SanitizedRender html={
          I18n.t(
            'discovery.addFollowToFeed.readableTitle',
            { titleText: this.props.readableTitle,
              strongOpen: '<strong>',
              strongClose: '</strong>',
            })
        }
        />
      </small>
    );
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        subClass="feed"
        onRequestClose={this.props.onRequestClose}
      >
        <h1 className="feed-modal__header">
          {this.props.headerLabel}
          {this.renderReadableTitle()}
        </h1>
        <div className="feed-modal__option">
          <div className="feed-modal__switch">
            <input
              type="checkbox"
              id="gear-alert-toggle"
              onChange={this.handleGearAlertChange}
              checked={this.props.addGearAlert}
              aria-checked={this.props.addGearAlert}
            />
            <label htmlFor="gear-alert-toggle">
              {I18n.t('discovery.addFollowToFeed.addToGearAlerts')}
            </label>
          </div>
        </div>
        {this.renderUsedFilter()}
        {this.renderPriceFilters()}
        <div className="feed-modal__action">
          <button id="submit-follow" onClick={this.handleSubmit}>
            {this.props.submitLabel}
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/feed/follow_modal.tsx